module.exports = __webpack_public_path__ + "static/media/Puste.3841e9cb.md";